<script setup lang="ts">
const props = defineProps<{
  slides: number
  loop?: boolean
  navigation?: boolean
  showBullet?: boolean
  navigationColor?: string | null
  nextSlide?: () => void
  prevSlide?: () => void
}>()

const BACKGROUND_COLORS: { [key: string]: string } = {
  yellow: '#ffbc0d',
  white: '#ffffff',
  black: '#000000',
}

const backgroundColor = computed(
  () => BACKGROUND_COLORS[props.navigationColor ? props.navigationColor : 'yellow']
)

const textColor = computed(() => {
  if (props.navigationColor === 'white' || props.navigationColor === 'yellow') {
    return '#000000'
  }
  return '#ffffff'
})
</script>
<template>
  <Swiper
    :modules="[SwiperEffectCreative, SwiperPagination, SwiperNavigation]"
    :slides-per-view="slides"
    :loop="loop"
    :short-swipes="true"
    :pagination="
      showBullet && {
        type: 'bullets',
        clickable: true,
      }
    "
    :style="[`--swiper-navigation-color: ${textColor}; --swiper-pagination-color: #ffbc0d; `]"
    :navigation="navigation"
    @navigation-next="nextSlide"
    @navigation-prev="prevSlide"
  >
    <slot />
  </Swiper>
</template>

<style>
.swiper-button-prev {
  z-index: 0;
  @apply left-0 top-[40%];
}

.swiper-button-next {
  z-index: 0;
  @apply right-0 top-[40%];
}

.swiper-button-next,
.swiper-button-prev {
  @apply rounded-full border-2;
  background-color: v-bind(backgroundColor);
}

@media screen and (min-width: 768px) {
  .swiper-button-next,
  .swiper-button-prev {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }

  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 0.875rem !important;
  }
}

@media screen and (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }

  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 1.25rem !important;
  }
}
</style>
